<div class="container">
    <angular-editor [(ngModel)]="htmlContent" [config]="config"></angular-editor>

    <!-- <div class="html">
        {{ htmlContent }}
    </div> -->
</div>
<div class="new-post-container">
    <form [formGroup]="nuevoCursoForm" (ngSubmit)="guardarCurso(nuevoCursoForm.value)">
        <mat-form-field>
            <mat-label>Nombre curso</mat-label>
            <input matInput placeholder="Nombre curso" formControlName="nombre">
        </mat-form-field>
        <div class="container-input-file">
            <label class="custom-file">
        <input type="file" formControlName="imagenCurso" (change)="handleImagenCurso($event)" />
        <mat-icon>cloud_upload</mat-icon><span>Imagen curso</span>
      </label>
        </div>
        <div class="container-button">
            <input type="submit" class="mat-flat-button" value="Guardar" [mat-dialog-close]="true">
        </div>
    </form>
    <div>
        <p>Curso</p>
        <mat-list *ngFor="let item of listaCursos; let i = index">
            <mat-list-item (click)="buscarCursoId($event, i)" value="{{i}}"> {{item.nombre}} </mat-list-item>
       
        </mat-list>
    </div>
    <form [formGroup]="newPostForm" (ngSubmit)="addNewPost(newPostForm.value)">
        <mat-form-field>
            <mat-label>Título</mat-label>
            <input matInput placeholder="Título" formControlName="titlePost">
        </mat-form-field>
        <!-- <mat-form-field>
            <mat-label>Content</mat-label>
           <input matInput placeholder="Content post" formControlName="contentPost">

        </mat-form-field> -->
        <div class="html">
            {{ htmlContent }}
        </div>
        <!-- <mat-form-field>
            <mat-select placeholder="Tags" multiple formControlName="tagsPost">
                <mat-option value="life">Life</mat-option>
                <mat-option value="sport">Sport</mat-option>
                <mat-option value="beauty">Beauty</mat-option>
            </mat-select>
        </mat-form-field> -->
        <div class="container-input-file">
            <label class="custom-file">
        <input type="file" formControlName="imagePost" (change)="handleImage($event)" />
        <mat-icon>cloud_upload</mat-icon><span>Imagen</span>
      </label>
        </div>
        <div class="container-button">
            <input type="submit" class="mat-flat-button" value="Guardar" [mat-dialog-close]="true">
        </div>
    </form>
</div>
